export const QUESTION_TYPES = {
  MC: 'Multiple Choice' as const,
  MCA: 'Multiple Response' as const,
  TF: 'True or False' as const,
  M: 'Matching' as const,
  ORD: 'Ordering' as const,
  OT: 'Open Text' as const,
}

export const BLOCKED_FILE_EXTENSIONS = ['']
